import MessagesMenuV1 from 'app/menu/components/TopBarV1/Messages'

export const MessagesMenu = MessagesMenuV1
export default MessagesMenu
